//get my library
export const GET_MY_LIBRARY_REQUEST = "GET_MY_LIBRARY_REQUEST";
export const GET_MY_LIBRARY_RECEIVE = "GET_MY_LIBRARY_RECEIVE";
export const GET_MY_LIBRARY_FAILURE = "GET_MY_LIBRARY_FAILURE";
export const RESET_GET_MY_LIBRARY = "RESET_GET_MY_LIBRARY";

//duplicate video
export const DUPLICATE_VIDEO_REQUEST = "DUPLICATE_VIDEO_REQUEST";
export const DUPLICATE_VIDEO_RECEIVE = "DUPLICATE_VIDEO_RECEIVE";
export const DUPLICATE_VIDEO_FAILURE = "DUPLICATE_VIDEO_FAILURE";
export const RESET_DUPLICATE_VIDEO = "RESET_DUPLICATE_VIDEO";

//delete video
export const DELETE_VIDEO_REQUEST = "DELETE_VIDEO_REQUEST";
export const DELETE_VIDEO_RECEIVE = "DELETE_VIDEO_RECEIVE";
export const DELETE_VIDEO_FAILURE = "DELETE_VIDEO_FAILURE";
export const RESET_DELETE_VIDEO = "RESET_DELETE_VIDEO";

//publish video
export const PUBLISH_VIDEO_REQUEST = "PUBLISH_VIDEO_REQUEST";
export const PUBLISH_VIDEO_RECEIVE = "PUBLISH_VIDEO_RECEIVE";
export const PUBLISH_VIDEO_FAILURE = "PUBLISH_VIDEO_FAILURE";
export const RESET_PUBLISH_VIDEO = "RESET_PUBLISH_VIDEO";

//publish video
export const GET_UPLOAD_LINK_REQUEST = "GET_UPLOAD_LINK_REQUEST";
export const GET_UPLOAD_LINK_RECEIVE = "GET_UPLOAD_LINK_RECEIVE";
export const GET_UPLOAD_LINK_FAILURE = "GET_UPLOAD_LINK_FAILURE";
export const RESET_GET_UPLOAD_LINK = "RESET_GET_UPLOAD_LINK";

//uploaded video
export const UPLOAD_VIDEO_CONTENT = "UPLOAD_VIDEO_CONTENT";
export const RESET_UPLOAD_VIDEO_CONTENT = "RESET_UPLOAD_VIDEO_CONTENT";

//set/edit pricing
export const ADD_EDIT_PRICING_CONTENT = "ADD_EDIT_PRICING_CONTENT";
export const RESET_ADD_EDIT_PRICING_CONTENT = "RESET_ADD_EDIT_PRICING_CONTENT";

//add video to library
export const ADD_VIDEO_TO_LIBRARY_REQUEST = "ADD_VIDEO_TO_LIBRARY_REQUEST";
export const ADD_VIDEO_TO_LIBRARY_RECEIVE = "ADD_VIDEO_TO_LIBRARY_RECEIVE";
export const ADD_VIDEO_TO_LIBRARY_FAILURE = "ADD_VIDEO_TO_LIBRARY_FAILURE";
export const RESET_ADD_VIDEO_TO_LIBRARY = "RESET_ADD_VIDEO_TO_LIBRARY";

//Add/Edit  Pricing
export const ADD_EDIT_PRICING_REQUEST = "ADD_EDIT_PRICING_REQUEST";
export const ADD_EDIT_PRICING_RECEIVE = "ADD_EDIT_PRICING_RECEIVE";
export const ADD_EDIT_PRICING_FAILURE = "ADD_EDIT_PRICING_FAILURE";
export const RESET_ADD_EDIT_PRICING = "RESET_ADD_EDIT_PRICING";

//Add/Edit  Pricing
export const ADD_VIDEO_TO_GALLERY_REQUEST = "ADD_VIDEO_TO_GALLERY_REQUEST";
export const ADD_VIDEO_TO_GALLERY_RECEIVE = "ADD_VIDEO_TO_GALLERY_RECEIVE";
export const ADD_VIDEO_TO_GALLERY_FAILURE = "ADD_VIDEO_TO_GALLERY_FAILURE";
export const RESET_ADD_VIDEO_TO_GALLERY = "RESET_ADD_VIDEO_TO_GALLERY";

//add video to library
export const EDIT_VIDEO_TO_LIBRARY_REQUEST = "EDIT_VIDEO_TO_LIBRARY_REQUEST";
export const EDIT_VIDEO_TO_LIBRARY_RECEIVE = "EDIT_VIDEO_TO_LIBRARY_RECEIVE";
export const EDIT_VIDEO_TO_LIBRARY_FAILURE = "EDIT_VIDEO_TO_LIBRARY_FAILURE";
export const RESET_EDIT_VIDEO_TO_LIBRARY = "RESET_EDIT_VIDEO_TO_LIBRARY";

//get my gallery
export const GET_MY_GALLERY_REQUEST = "GET_MY_GALLERY_REQUEST";
export const GET_MY_GALLERY_RECEIVE = "GET_MY_GALLERY_RECEIVE";
export const GET_MY_GALLERY_FAILURE = "GET_MY_GALLERY_FAILURE";
export const RESET_GET_MY_GALLERY = "RESET_GET_MY_GALLERY";

//add gallery to library
export const ADD_GALLERY_REQUEST = "ADD_GALLERY_REQUEST";
export const ADD_GALLERY_RECEIVE = "ADD_GALLERY_RECEIVE";
export const ADD_GALLERY_FAILURE = "ADD_GALLERY_FAILURE";
export const RESET_ADD_GALLERY = "RESET_ADD_GALLERY";

//edit gallery to library
export const EDIT_GALLERY_REQUEST = "EDIT_GALLERY_REQUEST";
export const EDIT_GALLERY_RECEIVE = "EDIT_GALLERY_RECEIVE";
export const EDIT_GALLERY_FAILURE = "EDIT_GALLERY_FAILURE";
export const RESET_EDIT_GALLERY = "RESET_EDIT_GALLERY";

//delete gallery from the library
export const DELETE_GALLERY_REQUEST = "DELETE_GALLERY_REQUEST";
export const DELETE_GALLERY_RECEIVE = "DELETE_GALLERY_RECEIVE";
export const DELETE_GALLERY_FAILURE = "DELETE_GALLERY_FAILURE";
export const RESET_DELETE_GALLERY = "RESET_DELETE_GALLERY";